import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

export default function BankFeedsPage() {
  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        <AccountBalanceIcon sx={{ mr: 1 }} />
        Bank Feeds
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6">Connect a Bank Account</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Automatically import your bank transactions securely using Open Banking.
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button variant="contained" color="primary">
            Add Bank Account
          </Button>
          <Button variant="outlined">View Connected Accounts</Button>
        </Stack>
      </Paper>

      <Divider sx={{ my: 3 }} />

      <Typography variant="subtitle1">Connected Bank Accounts</Typography>
      <Typography variant="body2" color="text.secondary">
        No accounts connected yet. Use the button above to get started.
      </Typography>
    </Box>
  );
}
